export default __webpack_public_path__ + "static/media/main3(1).8a7ec0af.png";